import React from 'react';

import baby from '../Assets/Images/Icons/baby.png';
import boy from '../Assets/Images/Icons/boy.png';
import incognito from '../Assets/Images/Icons/incognito.png';
import girl from '../Assets/Images/Icons/girl.png';
import man from '../Assets/Images/Icons/man.png';
import woman from '../Assets/Images/Icons/woman.png';

export default function IconAvatar(props)
{
    var icon = "";

    if (props.isincognito)
    {
        icon = incognito;
    } else if (props.age <4)
    {
        icon = baby;
    } else if (props.age < 18)
    {
        icon = props.ism ? boy : girl;
    } else {
        icon = props.ism ? man : woman;
    }

    return (
        <img src={icon} alt='' onClick={() => props.Click()}
            className={props.isincognito?'avatar hover_pointer':'avatar'}/>
    );
}